export default __webpack_public_path__ + "static/media/816.edefbc5c.png";